import React, { Component } from 'react';
import Link from '../common/TrackedLink';
import { pushMenuItem, pushSocialItem } from "../../utils/datalayer";

const dataLayer = global.dataLayer;
let eventAction;

class Footer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			options: [],
			selected: null,
			subMenuProducts: false,
			subMenuLearn: false,
			subMenuSupport: false,
			subMenuOurBrands: false
		};
	}

	handleClickProducts(e) {
		this.setState({
			subMenuLearn: false,
			subMenuSupport: false,
			subMenuOurBrands: false
		});
		if (this.state.subMenuProducts === false) {
			this.setState({ subMenuProducts: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuProducts: false });
			eventAction = 'collapse';
		}
		// dataLayer.push({
		// 	event: 'Footer',
		// 	eventCategory: 'Footer',
		// 	eventAction,
		// 	eventLabel: e.currentTarget.textContent
		// });
	}

	handleClickLearn(e) {
		this.setState({
			subMenuProducts: false,
			subMenuSupport: false,
			subMenuOurBrands: false
		});
		if (this.state.subMenuLearn === false) {
			this.setState({ subMenuLearn: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuLearn: false });
			eventAction = 'collapse';
		}
		// dataLayer.push({
		// 	event: 'Footer',
		// 	eventCategory: 'Footer',
		// 	eventAction,
		// 	eventLabel: e.currentTarget.textContent
		// });
	}

	handleClickSupport(e) {
		this.setState({
			subMenuProducts: false,
			subMenuLearn: false,
			subMenuOurBrands: false
		});
		if (this.state.subMenuSupport === false) {
			this.setState({ subMenuSupport: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuSupport: false });
			eventAction = 'collapse';
		}
		// dataLayer.push({
		// 	event: 'Footer',
		// 	eventCategory: 'Footer',
		// 	eventAction,
		// 	eventLabel: e.currentTarget.textContent
		// });
	}

	handleClickOurBrands(e) {
		this.setState({
			subMenuProducts: false,
			subMenuLearn: false,
			subMenuSupport: false
		});
		if (this.state.subMenuOurBrands === false) {
			this.setState({ subMenuOurBrands: true });
			eventAction = 'expand';
		} else {
			this.setState({ subMenuOurBrands: false });
			eventAction = 'collapse';
		}
		// dataLayer.push({
		// 	event: 'Footer',
		// 	eventCategory: 'Footer',
		// 	eventAction,
		// 	eventLabel: e.currentTarget.textContent
		// });
	}

	handleClickPrivacySettings(e) {
		// console.log('handleClickPrivacySettings()');

		//IE9 & Other Browsers
		if (e.stopPropagation) {
			// console.log("Stopping propagation");
			e.stopPropagation();
		}

		this.handleFooterMenuUtilityClick(e);
		// if (dataLayer) {
		// 	dataLayer.push({
		// 		event: 'Footer',
		// 		eventCategory: 'Footer',
		// 		eventAction: 'Privacy Settings',
		// 		eventLabel: e.currentTarget.textContent
		// 	});
		// }
		window.semaphore.push(['showPreferences'])
	}

	handleFooterMenuItemClick(e) {
		const target = e.currentTarget;

		const subNav = target.closest('dd');
		let menuPath;
		if (subNav) {
			const parent = subNav.previousSibling;
			menuPath = `${parent.textContent} > ${target.textContent}`;
		} else {
			menuPath = `${target.textContent}`;
		}
		pushMenuItem(e, 'Footer | Main', menuPath);
	}

	handleFooterMenuUtilityClick(e) {
		pushMenuItem(e, 'Footer | Utility');
	}

	render() {
		return (
			<footer id="site-footer">
				<nav className="row links">
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuProducts ? 'active' : ''}`}
							onClick={e => this.handleClickProducts(e)}
						>
							Products
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuProducts ? 'active' : ''}`}>
								<li>
									<Link
										to="/products"
										onClick={this.handleFooterMenuItemClick}
									>
										All Products
									</Link>
								</li>
								<li>
									<Link
										to="/fire-waterproof-safes"
										onClick={this.handleFooterMenuItemClick}
									>
										Water and Fireproof Safes
									</Link>
								</li>
								<li>
									<Link
										to="/security-safes"
										onClick={this.handleFooterMenuItemClick}
									>
										Security Safes
									</Link>
								</li>
								<li>
									<Link
										to="/document-safes"
										onClick={this.handleFooterMenuItemClick}
									>
										Document Safes
									</Link>
								</li>
								<li>
									<Link
										to="/pistol-safes"
										onClick={this.handleFooterMenuItemClick}
									>
										Pistol Safes
									</Link>
								</li>
								<li>
									<Link
										to="/fire-safes"
										onClick={this.handleFooterMenuItemClick}
									>
										Fire Safes
									</Link>
								</li>
								<li>
									<Link
										to="/cash-boxes"
										onClick={this.handleFooterMenuItemClick}
									>
										Cash Boxes
									</Link>
								</li>
								<li>
									<Link
										to="/business-safes"
										onClick={this.handleFooterMenuItemClick}
									>
										Business Safes
									</Link>
								</li>
								<li>
									<Link
										to="/portable-safes"
										onClick={this.handleFooterMenuItemClick}
									>
										Portable Safes
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuLearn ? 'active' : ''}`}
							onClick={e => this.handleClickLearn(e)}
						>
							Learn
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuLearn ? 'active' : ''}`}>
								<li>
									<Link
										to="/learn/buying-guide"
										onClick={this.handleFooterMenuItemClick}
									>
										Buying Guide
									</Link>
								</li>
								<li>
									<Link
										to="https://www.masterlock.com/insights"
										target="_blank"
										onClick={this.handleFooterMenuItemClick}
									>
										Security and Safety Insights
									</Link>
								</li>
								<li>
									<Link
										to="/learn/about-us"
										onClick={this.handleFooterMenuItemClick}
									>
										About SentrySafe
									</Link>
								</li>
								<li>
									<Link
										to="/learn/customer-stories"
										onClick={this.handleFooterMenuItemClick}
									>
										Customer Stories
									</Link>
								</li>
								<li>
									<Link
										to="https://www.masterlock.com/testimonial#submit-your-story"
										target="_blank"
										onClick={this.handleFooterMenuItemClick}
									>
										Share Your Story
									</Link>
								</li>
								<li>
									<Link
										to="/where-to-buy"
										onClick={this.handleFooterMenuItemClick}
									>
										Where To Buy
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuSupport ? 'active' : ''}`}
							onClick={e => this.handleClickSupport(e)}
						>
							Support
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuSupport ? 'active' : ''}`}>
								<li>
									<Link
										to="/support"
										onClick={this.handleFooterMenuItemClick}
									>
										All Support
									</Link>
								</li>
								<li>
									<Link
										to="/support/find-your-model-or-serial-number"
										onClick={this.handleFooterMenuItemClick}
									>
										Find Your Model or Serial Number
									</Link>
								</li>
								<li>
									<Link
										to="/support/faqs/how-do-i-change-the-batteries-on-my-safe"
										onClick={this.handleFooterMenuItemClick}
									>
										Need Help with Your Digital Lock&#63;
									</Link>
								</li>
								<li>
									<Link
										to="/support/faqs"
										onClick={this.handleFooterMenuItemClick}
									>
										FAQs
									</Link>
								</li>
								<li>
									<Link
										to="/support/lost-key-combo"
										onClick={this.handleFooterMenuItemClick}
									>
										Lost Key or Combo
									</Link>
								</li>
								<li>
									<Link
										to="/support/videos"
										onClick={this.handleFooterMenuItemClick}
									>
										Videos
									</Link>
								</li>
								<li>
									<Link
										to="/support/product-manuals"
										onClick={this.handleFooterMenuItemClick}
									>
										Product Manuals
									</Link>
								</li>
								<li>
									<Link
										to="/support/contact-us"
										onClick={this.handleFooterMenuItemClick}
									>
										Contact Us
									</Link>
								</li>
								<li>
									<Link
										to="https://eloquamarketing.masterlock.com/PreferenceCenter"
										target="_blank"
										onClick={this.handleFooterMenuItemClick}
									>
										Update Your Email Preferences
									</Link>
								</li>
								<li>
									<Link
										to="https://store.sentrysafe.com/"
										target="_blank"
										onClick={this.handleFooterMenuItemClick}
									>
										SentrySafe Store
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
					<dl>
						<dt
							className={`h3 nav-header ${this.state.subMenuOurBrands ? 'active' : ''}`}
							onClick={e => this.handleClickOurBrands(e)}
						>
							Our Brands
						</dt>
						<dd>
							<ul className={`nav-list ${this.state.subMenuOurBrands ? 'active' : ''}`}>
								<li>
									<Link
										to="https://www.masterlock.com/"
										target="_blank"
										rel="noopener"
										onClick={this.handleFooterMenuItemClick}
									>
										Master Lock
									</Link>
								</li>
								<li>
									<Link
										to="https://www.masterlock.com/americanlock"
										target="_blank"
										rel="noopener"
										onClick={this.handleFooterMenuItemClick}
									>
										American Lock
									</Link>
								</li>
								<li>
									<Link
										to="/"
										onClick={this.handleFooterMenuItemClick}
									>
										SentrySafe
									</Link>
								</li>
							</ul>
						</dd>
					</dl>
				</nav>
				<nav className="row social" itemScope itemType="https://schema.org/Organization">
					<link itemProp="url" href="https://www.sentrysafe.com" />
					<ul>
						<li>
							<Link
								to="https://www.facebook.com/sentrysafe/"
								className="fa fa-facebook"
								target="_blank"
								itemProp="sameAs"
								rel="me"
								onClick={(e) => { pushSocialItem(e) }}
							>
								<span className="assistive-text">
									Visit SentrySafe on Facebook
								</span>
							</Link>
						</li>
						{/*<li>*/}
						{/*	<Link*/}
						{/*		to="https://twitter.com/sentrysafe"*/}
						{/*		className="fa fa-twitter"*/}
						{/*		target="_blank"*/}
						{/*		itemProp="sameAs"*/}
						{/*		rel="me"*/}
						{/*		onClick={(e) => {pushSocialItem(e)}}*/}
						{/*	>*/}
						{/*		<span className="assistive-text">*/}
						{/*			Visit SentrySafe on Twitter*/}
						{/*		</span>*/}
						{/*	</Link>*/}
						{/*</li>*/}
						<li>
							<Link
								to="https://www.instagram.com/sentrysafe"
								className="fa fa-instagram"
								target="_blank"
								itemProp="sameAs"
								rel="me"
								onClick={(e) => { pushSocialItem(e) }}
							>
								<span className="assistive-text">
									Visit SentrySafe on Instagram
								</span>
							</Link>
						</li>
						<li>
							<Link
								to="https://www.youtube.com/user/SentryGroup"
								className="fa fa-youtube-play"
								target="_blank"
								trackEvent="Footer"
								trackEventAction="social icon"
								itemProp="sameAs"
								rel="me"
								onClick={(e) => { pushSocialItem(e) }}
							>
								<span className="assistive-text">
									Visit SentrySafe on YouTube
								</span>
							</Link>
						</li>
					</ul>
				</nav>
				<nav className="row">
					<div className="col legal">
						<ul>
							<li>
								<Link
									to="https://www.masterlock.com/privacy-policy"
									target="_blank"
									onClick={this.handleFooterMenuUtilityClick}
								>
									Privacy Policy
								</Link>
							</li>
							<li>
								<a href='#'
									onClick={e => this.handleClickPrivacySettings(e)}>
									Privacy Settings
								</a>
							</li>
							<li>
								<Link
									to="https://www.masterlock.com/legal-statement"
									target="_blank"
									onClick={this.handleFooterMenuUtilityClick}
								>
									Legal Statement
								</Link>
							</li>
							<li>
								<Link
									to="/site-map"
									onClick={this.handleFooterMenuUtilityClick}
								>
									Site Map
								</Link>
							</li>
							<li>
								<Link
									to="https://www.masterlock.com/about-our-ads"
									target="_blank"
									onClick={this.handleFooterMenuUtilityClick}
								>
									About Our Ads
								</Link>
							</li>
							<li>
								<Link
									to="https://www.fbin.com/app/uploads/2023/05/FBIN-Supplier-Code-of-Conduct.pdf"
									target="_blank"
									onClick={this.handleFooterMenuUtilityClick}
								>
									Supplier Code of Conduct
								</Link>
							</li>
						</ul>
						<div className="copyright">
							&copy; {new Date().getFullYear()} Sentry Group. All Rights Reserved.
						</div>
					</div>
				</nav>
			</footer>
		);
	};
}

export default Footer;



// WEBPACK FOOTER //
// ./src/pages/components/Footer.js